// src/axios.js
import axios from "axios";
import { useUserStore } from "@/stores/user";

const client = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT + "/api",
  headers: { "Content-Type": "application/json" },
});

let isRefreshing = false;
let failedRequests: any = [];

const processFailedRequests = (error: any, token = null) => {
  failedRequests.forEach((promise: any) => {
    if (token) {
      promise.resolve(token);
    } else {
      promise.reject(error);
    }
  });
  failedRequests = [];
};

// Request interceptor
client.interceptors.request.use(
  (config) => {
    const userStore = useUserStore();
    if (config.headers) {
      config.headers["x-supabase-auth"] = `${userStore.getAccessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const userStore = useUserStore();
    const originalRequest = error.config;

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error && error.response && error.response.status === 401) {
      console.log(userStore.getRefreshToken, "userStore.getRefreshToken");
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedRequests.push({ resolve, reject });
        })
          .then((token) => {
            console.log(token, "token");
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return client(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        console.log(userStore.getRefreshToken, "userStore.getRefreshToken");
        axios
          .post(`${process.env.VUE_APP_API_ENDPOINT}/api/auth/refresh-token`, {
            refreshToken: userStore.getRefreshToken,
          })
          .then(({ data }) => {
            const newAccessToken = data.accessToken;
            const newRefreshToken = data.refreshToken;
            userStore.setTokens(newAccessToken, newRefreshToken);

            client.defaults.headers[
              "Authorization"
            ] = `Bearer ${newAccessToken}`;

            originalRequest.headers[
              "Authorization"
            ] = `Bearer ${newAccessToken}`;

            processFailedRequests(null, newAccessToken);
            resolve(client(originalRequest));
          })
          .catch((err) => {
            console.log(failedRequests, "failedRequests");
            processFailedRequests(err, null);
            reject(err);
            // userStore.logout();
            // window.location.href = "/login";
            console.warn("[Token missing or invalid]");
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  }
);

export default client;
